import { render, staticRenderFns } from "./ShippingReturnFormV3.vue?vue&type=template&id=f566c8e0&scoped=true&"
import script from "./ShippingReturnFormV3.vue?vue&type=script&lang=js&"
export * from "./ShippingReturnFormV3.vue?vue&type=script&lang=js&"
import style0 from "./ShippingReturnFormV3.vue?vue&type=style&index=0&id=f566c8e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f566c8e0",
  null
  
)

export default component.exports